import { useHeaderContext } from '../../context/HeaderContext';

/**
 * Burger menu (NavIcon) visibility.
 * By default it is hidden from `lg` (1160px). With the new categories navigation
 * the categories entry point lives in the burger menu, so it stays visible up to `xl` (1400px),
 * where the header categories navigation takes over.
 */
export const useNavIconHiddenProps = () => {
    const { isNewCategoriesNavigation } = useHeaderContext();

    return isNewCategoriesNavigation
        ? ({ default: false, xl: true } as const)
        : ({ default: false, lg: true } as const);
};
